import { useSearchParams } from "react-router-dom";
import { DataImportForm } from "./DataImportForm";
import { DataImportStatus } from "./DataImportStatus";

/** A new import's form, or an existing import's status when the address names one. */
export function DataImportPanel() {
  const [searchParams] = useSearchParams();
  const importId = searchParams.get("id");

  return importId ? (
    <DataImportStatus key={importId} importId={importId} />
  ) : (
    <DataImportForm />
  );
}

export default DataImportPanel;
